<div class="container-fluid">
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title"  *ngIf="!selectedData">Add Notification</h4>
      <h4 class="modal-title"  *ngIf="selectedData">Update Notification</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-12">
          <form class="theme-form" [formGroup]="addNotificationForm">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="col-form-label pt-0" for="type">Notification For</label>
                  <select class="form-control resize-none" id="type"  aria-describedby="nameHelp" formControlName="notified_for">
                    <option value=""> Select Type</option>
                    <option value="USER">User</option>
                    <option value="STUDENT">Student</option>
                  </select>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label class="col-form-label">Select College</label>
                  <select class="form-control shadow-1px-light"   aria-describedby="nameHelp"
                          formControlName="college_id" required >
                    <option value="" selected>Select the College</option>
                    <option [value]="college.id" *ngFor="let college of colleges">{{college.name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label class="col-form-label pt-0" for="detail">Notification</label>
                  <textarea class="form-control resize-none" id="detail" type="status" cols="4" rows="4"  aria-describedby="nameHelp" placeholder="Enter Notification" formControlName="notification"></textarea>
                  <small *ngIf="submitted && addNotificationForm.get('notification').hasError('required')"
                         class="text-danger">
                    Field is required.
                  </small>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-footer d-lg-block">
      <button class="btn btn-primary mr-1 btn-raised pull-right" (click)="submit()" *ngIf="!selectedData" ><i class="fa fa-edit"></i> Submit</button>
      <button class="btn btn-primary mr-1 btn-raised pull-right" (click)="update()" *ngIf="selectedData" ><i class="fa fa-edit"></i> Upadte</button>
      <button class="btn btn-danger mr-1 btn-raised pull-left" (click)="modal.dismiss('Cross click')"><i class="fa fa-trash-o"></i> Cancel</button>
    </div>
  </ng-template>
  <div class="row m-b-50 P-0">
    <div class="col-12 P-0">
      <button class="btn btn-primary pull-right" (click)="openLg(content)"><i class="fa fa-plus-circle"></i> Add Notification</button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <!--Use class<code>.table-primary</code> inside thead tr element.-->
          <div class="row">
            <div class="col-6">
              <h5>List Notification Table</h5>
            </div>
            <div class="col-3">
              <form class="theme-form"  [formGroup]="collegeForm">
                <div class="form-group m-b-0 m-t-10">
                  <select class="form-control" id="name"  aria-describedby="nameHelp" style="border-radius: 0"
                          formControlName="college_id">
                    <option [value]="college.id" *ngFor="let college of colleges">{{college.name}}</option>
                  </select>
                </div>
              </form>
            </div>
            <div class="col-3">
              <form class="theme-form"  [formGroup]="notificationForForm">
              <div class="form-group m-b-0 m-t-10">
                <select class="form-control" id="notify_for"  aria-describedby="nameHelp" style="border-radius: 0"
                        formControlName="notify_for">
                  <option value="">Notification For</option>
                  <option value="USER">User</option>
                  <option value="STUDENT">Student</option>
                </select>
              </div>
              </form>
            </div>
          </div>
        </div>
        <div class="card-block row">
          <div class="col-sm-12 col-lg-12 col-xl-12">
            <div class="table-responsive">
              <table class="table text-center">
                <thead class="thead-light .bg-*">
                <tr>
                  <th scope="col" class="text-center">S.No</th>
                  <th scope="col" class="text-center ">Notification</th>
                  <th scope="col" class="text-center ">Created At</th>
                  <th scope="col" class="text-center">Status </th>
                  <th scope="col" class="text-center">Action </th>
                </tr>
                </thead>
                <tbody >
                <tr *ngFor="let followup of notifications;  index as i">
                  <td class="text-center">
                   {{i + 1}}
                  </td>
                  <td  class="text-center">{{followup?.notification}}</td>
                  <td  class="text-center">{{followup?.created_at}}</td>
                  <td  class="text-center">{{followup?.status}}</td>
                  <td>

<!--                    <i class="icofont icofont-edit mr-5px font-size-20 color-darkcyan" title="Edit"></i>-->
                    <i class="icofont icofont-edit m-l-5 font-size-20 color-darkcyan cursor-pointer"
                       title="Edit" (click)="openEditModal(content, followup)"></i>
                    <i class="fa-solid fa-lock cursor-pointer m-l-5 font-size-20 color-danger" title="In Active"
                       *ngIf="followup.status === 'ACTIVE' " (click)="changeStatus(followup, 'INACTIVE')"></i>
                    <i class="fa-solid fa-lock-open cursor-pointer m-l-5 font-size-20 color-success" title="Active"
                       *ngIf="followup.status === 'INACTIVE'" (click)="changeStatus(followup, 'ACTIVE')"></i>

                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="pagination-top">
            <ngb-pagination class="d-flex justify-content-center" (pageChange)="onPageChange($event)"
                            [(page)]="pagination.page"
                            [boundaryLinks]="true"
                            [collectionSize]="pagination.total"
                            [maxSize]="5"
                            [pageSize]="pagination.perpage">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
